enum ProfileTypes {
  PLATFORM = 'Platform',
  PERSONAL = 'Personal',
  COMPANY = 'Company',
  NONE = '',
}

export default ProfileTypes;
